
import { defineComponent, PropType, computed } from 'vue';
import { MaterialTree } from '../../../types';

export default defineComponent({
  name: 'SubjectCardHeader',
  props: {
    tree: {
      type: Object as PropType<MaterialTree>,
      required: true,
    },
    expanded: {
      type: Boolean,
    },
    progress: {
      type: Number,
    },
  },
  setup(props) {
    const stringLimit = (string = '', maxLength = 10) => {
      if (string.length && string.length > maxLength) {
        return string.substring(0, maxLength) + '...';
      } else {
        return string;
      }
    };
    const getTotalStudied = () => {
      let total = 0;
      props.tree.topics.forEach((topic) => {
        total += topic.materials.filter(
          (material) => material.history && material.history.studied
        ).length;
      });
      return total;
    };

    const getTotalMaterial = () => {
      return props.tree.topics.reduce((acc, topic) => {
        return acc + topic.materials.length;
      }, 0);
    };
    const getPercentage = () => {
      const totalMaterial = getTotalMaterial();
      const studied = getTotalStudied();
      const percent = totalMaterial > 0 ? (studied * 100) / totalMaterial : 0;
      return Math.round(percent);
    };
    const formatCountMaterials = computed(() =>
      getTotalStudied() > 1
        ? `${getTotalStudied()} Materiais estudados`
        : '1 Material Estudado'
    );
    return {
      formatCountMaterials,
      stringLimit,
      getTotalStudied,
      getPercentage,
      getTotalMaterial,
    };
  },
});
